(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-detail-tabs]').forEach(function(section){
  if(section.dataset.ready) return;
  section.dataset.ready='true';
  var tabs=section.querySelectorAll('[role="tab"]');
  tabs.forEach(function(tab){tab.addEventListener('click',function(){
    tabs.forEach(function(item){item.setAttribute('aria-selected','false');});
    section.querySelectorAll('[role="tabpanel"]').forEach(function(panel){panel.hidden=true;});
    tab.setAttribute('aria-selected','true');
    var panel=section.querySelector('#'+tab.getAttribute('aria-controls'));
    if(panel) panel.hidden=false;
  });});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-styles"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.documentElement.classList.add('supports-section-reveal');
  function prepare(root) {
    var nodes = (root || document).querySelectorAll('[data-section-reveal]:not([data-reveal-ready])');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    nodes.forEach(function (node) {
      node.setAttribute('data-reveal-ready', 'true');
      if (reduce || !('IntersectionObserver' in window)) {
        node.classList.add('is-visible');
        node.querySelectorAll('video').forEach(function (video) { if (reduce) video.pause(); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
      observer.observe(node);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(document); });
  else prepare(document);
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target); });
  window.setTimeout(function () {
    document.querySelectorAll('[data-section-reveal]').forEach(function (node) { node.classList.add('is-visible'); });
  }, 1800);
})();

  } catch(e) { console.error(e); }
})();
})();
